module.exports = __webpack_public_path__ + "img/country-hits.bc73e37a.png";